import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from "@angular/router";
import {
  PlatformLegalEntityDetailPageComponent
} from "@well/platform-administration/company/feature-platform-legal-entity-detail";

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: "",
        component: PlatformLegalEntityDetailPageComponent
      }
    ])
  ],
})
export class PlatformAdministrationCompanyShellModule {}
